import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetAllEducationService {

  constructor(private http: HttpClient) { }

  async getAllEducation() {
    try {
      let response = await this.http
        .get(`${appApiResources.getEducation}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getAllEducationSub() {
    return this.http
      .get(`${appApiResources.getEducation}`)

  }

}
